var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OssUpload',_vm._g(_vm._b({},'OssUpload',_vm.$_attrs,false),_vm.$listeners),[(!_vm.$_attrs.disabled)?_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("\n      点击上传\n    ")]):_vm._e()],1),_vm._v(" "),_c('preview',{ref:"preview",attrs:{"url":_vm.currUrl}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf8a8976","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OssPictureUpload/index.vue
// module id = null
// module chunks = 